import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Container,
  createStyles,
  Dialog,
  DialogActions,
  Divider,
  IconButton,
  makeStyles,
  Slide,
  Theme,
  Typography,
  withStyles,
  TextField
} from "@material-ui/core";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {useDispatch, useSelector} from "react-redux";
import {Loading} from '../commonLoadings';
import {setLoading,} from "../../../store/actions"
import {TransitionProps} from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from '@material-ui/core/DialogContent';
import {
  experienceCategories,
  moveNextPage,
  updateUserMetrics,
  validateSessionCode
} from "../../../store/actions/creator/creatorExperienceBuilder";
import UtilService from '../../../helper/service';
import roles from "../../../helper/roles";
import {getManageHubs, getSessionParticipants, onUpdateSelectedHubs} from "../../../store/actions/creator/creatorExperienceManager";
import {apiClient} from "../../../config/apiClient";
import {handleCopyFile, handleUpload} from "../../../helper/stimulus";

const styles = (theme: Theme) =>
  createStyles({
    tagmodalheader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      color: theme.palette.grey[500],
      fontFamily: 'roboto-bold',
    },
    closeBtnIcon: {
      color: '#212D4080',
      width: 24,
      height: 24,
      fontFamily: 'roboto-bold'
    },
    modaltitle: {
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'left'
    }
});

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F0F0F0',
    paddingTop: "30px",
    fontFamily: 'roboto-regular',
    height: '100%',
    overflowX: 'hidden',
  },
  content: {
    minHeight: '100%',
    padding: theme.spacing(4),
    paddingBottom: 100,
    paddingTop: theme.spacing(6),
    '@media (min-width: 2000px)': {
      width: 1600
    },
  },
  dialogWrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  actionBtn: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  contentDialog: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  copyBtn: {
    width: 87,
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    fontFamily: 'roboto-regular',
    color: '#fff',
    textTransform: 'none',
    boxShadow: 'none',
    fontSize: 14,
    '&:hover': {
        background: '#0f9fef',
        color: '#fff',
    },
  },
  cancelbtn: {
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  btn: {
    margin: 8
  },
  experienceName: {
    marginTop: '12px',
    fontWeight: 'bold',
    fontFamily: 'roboto-regular',
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.tagmodalheader} {...other}>
      <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon classes={{ root: classes.closeBtnIcon }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
}))(MuiDialogContent);

CopyExperienceModalDotMenu.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  experienceData: PropTypes.object,
  gotoCopyExperience: PropTypes.func
};

CopyExperienceModalDotMenu.defaultProps = {
  onClose: () => {
  }
};

function CopyExperienceModalDotMenu({open, onClose, experienceData, gotoCopyExperience }: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  // const {loading} = useSelector((state: any) => state.creatorDashboard);
  const { userMetrics, globalSaveSetting /*page, asyncThumbnailImg*/ } = useSelector((state: any) => state.creatorExperienceBuilder);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { totalExperienceCount, is_loading } = useSelector((state: any) => state.experience);
  const { managerHubList,managerSelectedHubs,managerLoading } = useSelector((state: any) => state.creatorExperienceManager);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [error, setError] = useState(false);
  const [experienceTitle, setExperienceTitle] = useState("");
  // const [sessionDatas, setSessionData] = useState([]);

  useEffect(() => {
    if (experienceData) {
      const session_id = Number(experienceData.session_id);
      const request: any = {session_id};
      if (loginUserData.department_id) {
        request['department_id'] = Number(loginUserData.department_id);
      }
      dispatch(getManageHubs(apolloClient.client, request));
		setExperienceTitle(experienceData.name)
    }
  }, [experienceData]);
	useEffect(() => {
		if (experienceData && experienceTitle) {
			experienceData.name = experienceTitle
		}
	}, [experienceTitle])
  
  useEffect(() => {
    if (!managerLoading && managerHubList.length > 0) {
      const checkedHubs = managerHubList.filter((hub: any) => hub.is_associate);
      const result = checkedHubs.map((hub: any) => {
        return {
          hub_id: hub.hub_id
        }
      });
      dispatch(onUpdateSelectedHubs(result));
    }
  }, [managerHubList, managerLoading]);

  const onMoveLastPage = () => {
      dispatch(moveNextPage(UtilService.detectSidebarConfig(userMetrics, globalSaveSetting).length-1))
  };
  // const onMovePage = (nextPage: number) => {
  //   if (UtilService.detectSidebarConfig(userMetrics).length - 1 >= nextPage) {
  //     dispatch(moveNextPage(nextPage))
  //   }
  // };
	const onChangeTitle = (event: any) => {
		if (!event.target.value) {
			setError(true)
		} else {
			setError(false)
		}
		setExperienceTitle(event.target.value);
	};

  const checkTrialFirstTimeBuilder = () => {
    return UtilService.checkTrialAccess(loginUserData, roles['trial']['builder'])
      && totalExperienceCount !== null
      && totalExperienceCount === 0
  };

  const getSessionEndTimeForCopyExp = () => {
    let hour = 24;
    if (experienceData && experienceData.session_type == 'ASYNC') {
      if (experienceData && experienceData.start && experienceData.end) {
        hour = (experienceData.end - experienceData.start) / 3600
      } else {
        hour = 24
      }
    } else {
      if (experienceData && experienceData.session_length && !isNaN(parseInt(experienceData.session_length))) {
        hour = parseInt(experienceData.session_length) / 3600
      } else {
        hour = 1
      }
    }
    return hour
  };

  const onCopyExperience = async () => {

    dispatch(setLoading(true));
    
    if (experienceData && experienceData.session_category && experienceData.session_subcategory) {
      localStorage.setItem("copyExpId", experienceData.session_id);
     
      const participants: any = [];
      if(experienceData){

        dispatch(updateUserMetrics('iscopyExperience', true));
        dispatch(experienceCategories(apolloClient.client));
        
        const getOldStimulasData = {
          "requestor": "experience",
          "tenant_id": loginUserData.customer_id
        };
        const tokenres = await apiClient(false).post('/registration/v2/session/tokens', getOldStimulasData);
        if (tokenres && tokenres.data && tokenres.data.token) {
          const checkSession = await validateSessionCode(apolloClient.client, tokenres.data.token);
          if(checkSession && checkSession.data && checkSession.data.validateSessionCode){
            localStorage.setItem("session_code", String(tokenres.data.token));
            dispatch(updateUserMetrics('sessionCode', tokenres.data.token));
            dispatch(updateUserMetrics('selectedSessions', experienceData));
          } 
        } 

        dispatch(getSessionParticipants(apolloClient.client, { session_code: experienceData.session_code, isloading: true}, (participantRes: any) => {
          participantRes.participants && participantRes.participants.map((participant: any)=>{
            participants.push({email:participant.temp_email, tag: (participant.tag_cloud) ? participant.tag_cloud : []})
          })

          if(participantRes.session) {
            dispatch(updateUserMetrics('enable_controls', participantRes.session.enable_controls));
            dispatch(updateUserMetrics('enable_watermark', participantRes.session.enable_watermark));
          }
          // dispatch(setLoading(false)); 
        }));
        dispatch(updateUserMetrics('asyncParticipants', participants));
        
        const getStimulus = async () => {
          const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${experienceData.session_code}`);
          
          if (experienceData.session_type == 'ASYNC') {
            
            dispatch(updateUserMetrics('path', 1));
            dispatch(updateUserMetrics('asyncExperienceName', experienceData.name));
            dispatch(updateUserMetrics('surveyLink', experienceData.survey_link));
            
            const startDate = UtilService.getAsyncAddminuite();
            dispatch(updateUserMetrics('asyncStartDateTime', startDate));
            dispatch(updateUserMetrics('asyncEndDateTime', UtilService.getXHoursAboveDateTime(startDate, getSessionEndTimeForCopyExp())));


            if(res.data[0].stream_type === 'VDO'){
              dispatch(updateUserMetrics('isLink', false));
              const copyexperience:any = res.data[0];
              copyexperience.url = res.data[0].stimulus_link;
              copyexperience.streamType = res.data[0].stream_type;
              copyexperience.sourceId = res.data[0].id;
              
              dispatch(updateUserMetrics('copyExperience', copyexperience));
              dispatch(updateUserMetrics('asyncFile', " "));
              dispatch(updateUserMetrics('asyncFileName', res.data[0].stimulus_link ? res.data[0].stimulus_link.split("/").pop() : ""));

              const payload = {
                file: res.data[0].stream_type && res.data[0].stream_type === "VDO" ? " " : null,
                fileName: '',
                streamType: res.data[0].stream_type,
                stimulusType: res.data[0].stimulus_type,
                sessionCode: localStorage.getItem('session_code'),
                sortOrder: "1",
                tenantId: loginUserData.customer_id,
                stimulusAlias: experienceData.name,
                stimulusDescription: res.data[0].stimulus_link,
                operation: res.data[0].stream_type && res.data[0].stream_type === "VDO" ? "COPY" : "",
                sourceId: res.data[0].id && res.data[0].stream_type && res.data[0].stream_type === "VDO" ? res.data[0].id : ""
              };
              
              try {
                const copyupload: any = await handleCopyFile(payload);
                
                if (copyupload && copyupload.key) {
                  dispatch(updateUserMetrics('linkUploaded', true));
                  dispatch(updateUserMetrics('fileUploaded', false));

                  setTimeout(() => {
                    gotoCopyExperience();
                    !is_loading && closeCopyModal();
                  }, 3000);
                } else {
                  dispatch(updateUserMetrics('linkUploaded', false));
                  dispatch(updateUserMetrics('fileUploaded', false));
                }
              } catch (e) {
                dispatch(setLoading(false));
              }
            }else{
              const payload = {
                file: null,
                fileName: '',
                streamType: res.data[0].stream_type,
                stimulusType: res.data[0].stimulus_type,
                sessionCode: localStorage.getItem('session_code'),
                sortOrder: "1",
                tenantId: loginUserData.customer_id,
                stimulusAlias: experienceData.name,
                stimulusDescription: res.data[0].stimulus_link ? res.data[0].stimulus_link : ''
              };
              
              try {
                const uploaddata: any = await handleUpload(payload);
                
                if (uploaddata && uploaddata.key) {
                  dispatch(updateUserMetrics('linkUploaded', true));
                  dispatch(updateUserMetrics('fileUploaded', false));
                  dispatch(updateUserMetrics('asyncFileName', ''));
                  dispatch(updateUserMetrics('asyncFile', null));
                  setTimeout(() => {
                    gotoCopyExperience();
                    !is_loading && closeCopyModal();
                  }, 3000);
                } else {
                  dispatch(updateUserMetrics('linkUploaded', false));
                  dispatch(updateUserMetrics('fileUploaded', false));
                }
              } catch (e) {
                dispatch(setLoading(false));
              }
            }
            onMoveLastPage();
          } else {
            dispatch(updateUserMetrics('path', 2));
            dispatch(updateUserMetrics('moderatedName', experienceData.name));
            
            const startModDate = UtilService.getAsyncAddminuite();
            dispatch(updateUserMetrics('modStartDateTime', startModDate));
            dispatch(updateUserMetrics('modEndDateTime', UtilService.getXHoursAboveDateTime(startModDate, getSessionEndTimeForCopyExp())));

            if(experienceData.session_category == 'MEETING' && experienceData.session_subcategory == 'CALENDAR'){
              dispatch(updateUserMetrics('moderatedInviteWay', 'calendar'));
            }else{
              dispatch(updateUserMetrics('moderatedInviteWay', 'link'));
            }
            onMoveLastPage();

            setTimeout(() => {
              gotoCopyExperience();
              !is_loading && closeCopyModal();
            }, 3000);
          }

          if(managerSelectedHubs && managerSelectedHubs.length > 0){
            dispatch(updateUserMetrics('selectedHubs', managerSelectedHubs));
          }
          dispatch(updateUserMetrics('trialFirstStep', false));
          dispatch(updateUserMetrics('content', experienceData.session_category ? experienceData.session_category : ''));
          dispatch(updateUserMetrics('item', experienceData.session_subcategory ? experienceData.session_subcategory : ''));
          dispatch(updateUserMetrics('asyncVideoUrl', res.data[0].stimulus_link));
          dispatch(updateUserMetrics('asyncFileType', res.data[0].stimulus_type));
          dispatch(updateUserMetrics('stimulusList', res.data));
          dispatch(updateUserMetrics('streamType', res.data[0].stream_type));
          dispatch(updateUserMetrics('otherSubmitted', false));
          checkTrialFirstTimeBuilder() && dispatch(updateUserMetrics('myOwn', false)); // go Great Choice page
          if(res.data[0].stream_type != 'VDO'){
            dispatch(updateUserMetrics('fileUploaded', false));
            dispatch(updateUserMetrics('asyncFile', null));
            dispatch(updateUserMetrics('isLink', true));
          }
        };
        getStimulus();
      }
    }
  };

  // close modal
  const closeCopyModal = () => {
    onClose();
    dispatch(onUpdateSelectedHubs([]));
	setError(false)
    dispatch(setLoading(false));
  };

  return (
     <Dialog
        disableEscapeKeyDown
        open={open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={"sm"}
        classes={{
          paper: classes.dialogWrap
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" onClose={closeCopyModal}>
          {"Copy Experience?"}
        </DialogTitle>
        <Divider />
        <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Container maxWidth="md">
            <Typography className={classes.contentDialog}>Are you sure you want to copy this experience? This will copy the experience setup specifications for a new experience prepped for new measurements<br /></Typography>
				  <TextField
					  value={experienceTitle}
					  fullWidth
					  margin="normal"
					  id="exp_title"
					  label="Experience Title"
					  name="exp_title"
					  onChange={onChangeTitle}
					  error={error}
					  helperText={error ? "Experience title is required" : ""}
				  />
			<br/>
            <Typography className={classes.contentDialog}>This operation cannot be undone.</Typography>
          </Container>
        </DialogContent>
        <DialogActions>
          <Container maxWidth="md" className={classes.actionBtn}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Box mr={2}>
                <Button
                  onClick={closeCopyModal}
                  variant="contained"
                  className={classes.cancelbtn}
                >
                  Cancel
                </Button>
              </Box>
              <Button
                onClick={onCopyExperience}
                variant="contained"
                disabled={managerLoading}
                color="secondary"
                className={classes.copyBtn}
              >
                {is_loading ? <Loading style={{ width: 60, height: 30, marginTop: -20 }} /> : 'Copy'}
              </Button>
            </Box>
          </Container>
        </DialogActions>
      </Dialog>
  );
}

export default CopyExperienceModalDotMenu;
